module.exports = __webpack_public_path__ + "img/businessScenario.9a223c9f.jpg";